import React, { useEffect, useState } from "react";
import ApiServices from "../../services/apiServices";
import "./index.css";
import storage from "../../services/storage";
import { toast } from "react-toastify";
import { useLoad } from "../../context/Load";
import ForcaSenha from "../../Components/ForcaSenha";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useNavigate } from "react-router";
import Tabela from "../../Components/Tabela";
import { FaRegEdit } from "react-icons/fa";
import {
  FiInbox,
  FiAlertCircle,
  FiHelpCircle,
  FiCheckCircle,
} from "react-icons/fi";
import moment from "moment";

const cardsStatus = [
  { id: 1, titulo: "Entrada", icone: <FiInbox />, classe: "entrada" },
  { id: 4, titulo: "Em andamento", icone: <FiAlertCircle />, classe: "andamento" },
  {
    id: 2,
    titulo: "Aguardando participante",
    icone: <FiHelpCircle />,
    classe: "aguardando",
  },
  { id: 3, titulo: "Finalizados", icone: <FiCheckCircle />, classe: "finalizado" },
];

export default function Chamado() {
  const [listaChamados, setListaChamados] = useState([]);
  const [statusSelecionado, setStatusSelecionado] = useState(1);
  const [contagens, setContagens] = useState({});

  const [filtroColuna, setFiltroColuna] = useState([]);
  const [novoFiltroColuna, setNovoFiltroColuna] = useState([]);
  const navigate = useNavigate();
  const { load, setLoad } = useLoad();
  const [paginacao, setPaginacao] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const colunas = [
    {
      accessorKey: "dataHora",
      header: "Data/hora de criação",
      muiTableHeadCellProps: {
        align: "left",
      },
      muiTableBodyCellProps: {
        align: "left",
      },
    },
    {
      accessorKey: "nome",
      header: "Nome",
      muiTableHeadCellProps: {
        align: "left",
      },
      muiTableBodyCellProps: {
        align: "left",
      },
    },
    {
      accessorKey: "assunto",
      header: "Motivo do contato",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "diasEmAberto",
      header: "Dias na fila",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "status",
      header: "Status",
      enableColumnFilter: false, // filtrado pelos cards
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },

    {
      header: "Ações",
      size: 90,
      id: "mrt-custom-actions",
      accessor: (row) => row, // Pode ser ajustado conforme necessário
      Cell: ({ row }) => (
        <div
          className="pointer"
          onClick={() => {
            navigate(
              "/fale-conosco/chamado/editar/" + row.original.faleConoscoId
            );
          }}
        >
          <FaRegEdit style={{ fontSize: 20 }} />
        </div>
      ),
      muiTableHeadCellProps: { align: "right" },
      muiTableBodyCellProps: { align: "right" },
    },
  ];

  async function fnExtrairChamados() {
    const parametros = {
      nome: novoFiltroColuna.nome || "",
      data: novoFiltroColuna.dataHora || "",
      motivo: novoFiltroColuna.assunto || "",
      diasNaFila: novoFiltroColuna.diasEmAberto || "",
      status: statusSelecionado || "",
    };

    try {
      setLoad(true);
      const queryString = new URLSearchParams(parametros).toString();
      let response = await ApiServices.apiDownloadXlsxGET(
        `relatorios/faleconosco?${queryString}`,
        "faleconosco"
      );
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }
  async function fnListarChamados() {
    const parametros = {
      nome: novoFiltroColuna.nome || "",
      data: novoFiltroColuna.dataHora || "",
      motivo: novoFiltroColuna.assunto || "",
      diasNaFila: novoFiltroColuna.diasEmAberto || "",
      status: statusSelecionado || "",
    };
    try {
      setLoad(true);
      const queryString = new URLSearchParams(parametros).toString();
      let response = await ApiServices.apiGet(
        `faleconosco/listagem?${queryString}`
      );
      if (response.statusCode == 200) {
        response.data.forEach((e) => {
          e.dataHora = moment(e.dataHora).format("DD/MM/YYYY HH:mm:ss");
        });
        setListaChamados(response.data);
      } else {
        toast.error(response.message);
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  async function fnContarChamados() {
    try {
      const respostas = await Promise.all(
        cardsStatus.map((c) =>
          ApiServices.apiGet(
            `faleconosco?faleConoscoStatusId=${c.id}&pageSize=1`
          )
        )
      );
      const novasContagens = {};
      cardsStatus.forEach((c, i) => {
        novasContagens[c.id] = respostas[i].data?.totalCount ?? 0;
      });
      setContagens(novasContagens);
    } catch (err) {
      console.error("err", err);
    }
  }

  useEffect(() => {
    fnContarChamados();
  }, []);

  useEffect(() => {
    const newObject = {};

    filtroColuna.forEach((item) => {
      newObject[item.id] = item.value;
    });
    setNovoFiltroColuna(newObject);
  }, [filtroColuna]);

  useEffect(() => {
    fnListarChamados();
  }, [novoFiltroColuna, statusSelecionado]);

  return (
    <>
      <div className="row">
        <span className="tituloPagina">FALE CONOSCO</span>

        <div className="col-md-3">
          <button className="btn btn-primary my-2" onClick={fnExtrairChamados}>
            Extrair chamados
          </button>
        </div>
        <div className="subTituloPagina">Histórico de chamados</div>
      </div>
      <div className="row g-3 my-2">
        {cardsStatus.map((c) => (
          <div className="col-6 col-lg-3" key={c.id}>
            <button
              type="button"
              className={`chamadoCardStatus ${c.classe} ${
                statusSelecionado === c.id ? "selecionado" : ""
              }`}
              onClick={() => {
                setStatusSelecionado(statusSelecionado === c.id ? null : c.id);
                setPaginacao((prev) => ({ ...prev, pageIndex: 0 }));
              }}
            >
              <span className="chamadoCardIcone">{c.icone}</span>
              <span className="chamadoCardTitulo">{c.titulo}</span>
              <span className="chamadoCardContagem">
                {contagens[c.id] ?? "-"}
              </span>
            </button>
          </div>
        ))}
      </div>
      <Tabela
        colunas={colunas}
        dados={listaChamados}
        setPaginacao={setPaginacao}
        paginacao={paginacao}
        filtroColuna={filtroColuna}
        setFiltroColuna={setFiltroColuna}
      />
    </>
  );
}
